import { render } from "./BuekProjectIframe.vue?vue&type=template&id=41549bda&ts=true"
import script from "./BuekProjectIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekProjectIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__